import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import actions from '../../actions/actions';
import BookWidget from '../BookWidget/BookWidget';
import {EdapProvider} from '@homeaway/react-event-tracking';
import Cookies from 'js-cookie';

function mapStateToProps(state) {
    // Each container component will likely only pull in the state that
    // it cares about. Doing so will eliminate unnecessary rerenders.
    return state;
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(actions, dispatch), dispatch};
}

const defaultFields = {eventcategory: 'book now widget'};

@connect(mapStateToProps, mapDispatchToProps)
class Page1Container extends Component {
    constructor(props) {
        super(props);
        this.state = {
            csu: null,
            hav: null
        };
    }

    getUrlParams(search) {
        const hashes = search.slice(search.indexOf('?') + 1).split('&');
        const params = {};
        hashes.map((hash) => {
            const [key, val] = hash.split('=');
            params[key] = decodeURIComponent(val);
        });
        return params;
    }

    componentDidMount() {
        const params = this.getUrlParams(window.location.search);
        let hav;
        if (params.csu) {
            hav = Cookies.get('hav');
            this.setState({
                csu: params.csu,
                hav
            });
        }
    }

    render() {
        return (
            <div>
                <EdapProvider fields={defaultFields}>
                    <BookWidget {...this.props}/>
                </EdapProvider>
                {this.state.csu && this.state.hav &&
                    <img src={`https://www.canadastays.com/hav/${this.state.csu}_${this.state.hav}.gif`} width="1" height="1" />}
            </div>
        );
    }
}

export default Page1Container;
